<template>
  <div class="main" v-if="fieldsProvider">
    <dynamicForm
      ref="form"
      :fieldsProvider="fieldsProvider"
      :previewProvider="previewProvider"
      :execProvider="execProvider"
      @execd="onExecd($event)"
      :fullHeight="true"
    />
  </div>
</template>

<script>
import dynamicForm from '@/components/dynamicForm'

export default {
  name: 'do-action',
  props: {
    iscommon: Boolean
  },
  beforeRouteLeave(to, from, next) {
    if (this.canNotLeave()) {
      next(false)
    } else {
      next()
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.canNotLeave()) {
      next(false)
    } else {
      next()
    }
  },
  mounted() {
    // Note: The message in the beforeunload event is not customizable in modern browsers
    // so this will display a generic message when the user tries to leave the page with unsaved changes.
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  computed: {
    actionEntity() {
      return `${this.$route.params.type}_${this.$route.params.actiontype}`
    },
    fieldsProvider() {
      return this.apiClient.fieldsProvider(this.actionEntity)
    },
    previewProvider() {
      return this.apiClient.mutationProvider(this.actionEntity, `preview${this.actionEntity}`)
    },
    execProvider() {
      return this.apiClient.mutationProvider(this.actionEntity, `exec${this.actionEntity}`)
    },
    apiClient() {
      if (this.iscommon) {
        return this.$store.getters.api.common()
      } else {
        return this.$store.getters.api.trust(this.$route.params.trust)
      }
    }
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.canNotLeave()) {
        event.preventDefault()
        event.returnValue = ''
      }
    },
    canNotLeave() {
      return (
        this.$refs &&
        this.$refs.form.hasChanges &&
        !window.confirm('Du har osparade ändringar.\nÄr du säker på att du vill lämna?')
      )
    },
    onExecd(e) {
      if (!e.WaitFor || (!e.ID && e.WaitFor.indexOf('_:direct') !== 0)) {
        return
      }
      this.$router.push({
        name: this.iscommon ? 'common-wait-for' : 'wait-for',
        params: {
          type: this.$route.params.type,
          trust: this.$route.params.trust,
          primaryKey: `${e.ID || '_'}`,
          condition: e.WaitFor
        }
        // query: {
        //   open: 'true'
        // }
      })
    }
  },
  components: {
    dynamicForm
  }
}
</script>
